if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        copyButton: '.copy',
        copySuccess: '.copy-success',
      };
      this.copyButton = this.querySelector(this.selectors.copyButton);
      this.copySuccess = this.querySelector(this.selectors.copySuccess);
      this.copyButton?.addEventListener('click', this.copyToClipboard.bind(this));
    }

    copyToClipboard() {
      navigator.clipboard.writeText(window.location.href);
      this.copySuccess.classList.remove('hidden');
      setTimeout(() => {
        this.copySuccess.classList.add('hidden');
      }, 3000);
    }
  }
  customElements.define('social-share', SocialShare);
}

(() => {
  const enhanceArticle = () => {
    const root = document.querySelector('#singleBlogPost');
    if (!root || root.dataset.sgbEnhanced === '1') return;

    root.dataset.sgbEnhanced = '1';

    const categoryLink = root.querySelector('a.fs-13.btn-rounded[href*="/blogs/"]');
    if (categoryLink) {
      const categoryText = categoryLink.querySelector('span');
      if (categoryText) categoryText.textContent = 'LE MAG';
      categoryLink.setAttribute('aria-label', 'LE MAG');
    }

    const meta = root.querySelector('.article_meta');
    const articleBody = root.querySelector('.article-template__content');

    if (meta && articleBody && !meta.querySelector('.article-card-reading-time')) {
      const text = (articleBody.innerText || '').trim();
      const words = text ? text.split(/\s+/).length : 0;
      const minutes = Math.max(1, Math.ceil(words / 220));
      const lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();

      let label = minutes + ' min de lecture';
      if (lang === 'es') label = minutes + ' min de lectura';
      if (lang === 'en') label = minutes + ' min read';

      const readingTime = document.createElement('div');
      readingTime.className = 'article-card-reading-time dot-between inline-flex align-center';
      readingTime.textContent = label;
      meta.appendChild(readingTime);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceArticle, { once: true });
  } else {
    enhanceArticle();
  }
})();
